module.exports = "<div class=ms-frame_separator><div v-if=title class=ms-frame_separator-title-container><h3 class=ms-frame_separator-title>{{title}}</h3></div></div>";
